<!-- 教室设置 -->
<template>
  <div class="app-container">
    <!-- 查询条件区域 -->
    <el-collapse   v-model="activeName" accordion>
      <el-collapse-item :name="1">
        <template slot="title">
          <div class="title-container" shadow="never">
            <div class="title-con">
              <i class="el-icon-search"></i>
              <span style="margin-left: 5px;">筛选搜索</span>
            </div>
          </div>
        </template>
      <el-card class="operate-container" shadow="never" style="margin-top: 0px;">
          <div class="filter-container" style="margin-top: 10px ;">
            <el-form :inline="true" :model="queryParam" label-width="140px">
              <el-form-item label="标签名称:">
                <el-input v-model="queryParam.name" placeholder="标签名称"></el-input>
              </el-form-item>
            </el-form>
          </div>
          <div class="button-container" style="margin-top: 0px">
            <el-button type="warning" size="medium" class="operator-btn2" icon="el-icon-refresh" @click="handleResetSearch()">重 置</el-button>
            <el-button type="primary" size="medium" class="operator-btn" icon="el-icon-search" @click="onBtnSearch()">查 询</el-button>
          </div>
        </el-card>
      </el-collapse-item>

    </el-collapse>


    <!--    查询结果区域-->
    <div class="title-container" shadow="never" style="margin-top: 20px;">
      <div class="title-con">
        <i class="el-icon-tickets"></i>
        <span style="margin-left: 5px;">门店标签列表</span>
      </div>
      <div>
        <el-button type="primary" size="medium" class="operator-btn" icon="el-icon-circle-plus-outline" @click="handleCreateOne()">新增</el-button>
      </div>
    </div>
    <div class="table-container" style="margin-top: 0px;">
      <el-table
        :data="tableData"
        :header-cell-style="{'text-align':'center'}"
        :cell-style="{'text-align':'center'}"
        v-loading="listLoading"
        ref="seleteTable"
        max-height="650"
        border>
        <el-table-column prop="name" label="标签名称" ></el-table-column>
        <el-table-column prop="status" label="状态" :formatter="statusFormatter"></el-table-column>
        <el-table-column prop="showSearchFlag" label="是否作为查询条件" :formatter="booleanFormatter"></el-table-column>
        <el-table-column prop="createTime" label="创建时间" ></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button @click="handleEdit(scope.row)" type="primary" plain size="small">修改</el-button>
            <el-button @click="handleDeleteOne(scope.row)" type="danger" plain size="small">删除</el-button>
            <!-- <el-button @click="handleUpdateOneDlg(scope.row)" type="danger" plain size="small">修改</el-button> -->
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination-container">
      <el-pagination
              background
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              layout="total, sizes, prev, pager, next, jumper"
              :current-page="queryParam.pageNum"
              :page-size="queryParam.pageSize"
              :page-sizes="queryParam.pageSizes"
              :total="queryParam.totalPage">
      </el-pagination>
    </div>
    <el-dialog
            title="添加标签"
            :visible.sync="visibleDlgAdd"
            width="50%"
            center>
      <div>
        <el-form  ref="addForm"  :model="addParam" :rules="rules" label-width="150px">
          <el-form-item  label="标签名称" prop="name" >
            <el-input v-model="addParam.name" placeholder="请输入内容"></el-input>
          </el-form-item>
          <el-form-item  label="是否作为查询条件" prop="showSearchFlag" >
            <el-radio-group v-model="addParam.showSearchFlag">
              <el-radio :label="true">是</el-radio>
              <el-radio :label="false">否</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="visibleDlgAdd = false">取消</el-button>
        <el-button type="primary" @click="handleAddOne">保存</el-button>
      </span>
    </el-dialog>
    <el-dialog
            title="修改标签111"
            :visible.sync="visibleEditDlg"
            width="50%"
            center>
      <div>
        <el-form  ref="editForm"  :model="editParam" :rules="rules" label-width="150px">
          <el-form-item  label="标签名称" prop="name" >
            <el-input v-model="editParam.name" placeholder="请输入内容"></el-input>
          </el-form-item>
          <el-form-item  label="是否作为查询条件" prop="showSearchFlag" >
            <el-radio-group v-model="editParam.showSearchFlag">
              <el-radio :label="true">是</el-radio>
              <el-radio :label="false">否</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="visibleEditDlg = false">取消</el-button>
        <el-button type="primary" @click="handleEditOne">更新</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<style scoped>
  /deep/ .el-table th.el-table__cell>.cell{
    width: 90%;
    height: auto;
    background: #ecf3fd;
    border-radius: 8px;
  }
  /deep/ .el-table__header-wrapper .cell{
    line-height: 45px;
    color: #0d6fb8;
  }
  /deep/ .el-dialog--center{
    border: 2px solid #d0d0d0;
    border-radius: 10px;
  }
  /deep/ .el-dialog__header{
    border-radius: 10px;
    background: #f0f7ff;
  }
</style>

<script>
  import globaldata from "../../../utils/globaldata";
  import commonUtils from "../../../utils/commonUtils";
  import {tagList,tagAdd,tagInActiveById,tagUpdate} from "../../../api/storeFrontTag";
  import {getStaticData} from "@/api/staticData";
  import messageUtils from "../../../utils/messageUtils";
  import { getToken } from '@/utils/auth'
  export default {
    components:{},
    data() {
      return {
        fileList:[],
        srcList:[],
        videoFileList:[],
        visitPicList:[],
        refreVisitPic:"",
        uploadAction:'',
        importHeaders:'',
        listLoading: true,
        storeFrontId:globaldata.getAdminStore().storeFrontId,
        //查询参数
        queryParam: {
          //分页查询
          pageNum :1 ,//当前第几页
          pageSize : 10,
        },
        totalPage :1, //总共页数
        pageSizes:[20,50,100],
        //查询区域默认展开
        activeName:1,
        createParam :{
        },
        //删除
        deleteParam :{
        },
        addParam:{
          name:'',
          showSearchFlag :false,
        },
        editParam:{
        },
        //弹窗
        visibleDlgAdd: false,
        visibleEditDlg:false,
        //表单结果
        tableData: [
        ],
        allWorker:[],

        rules:{
          name:[{required:true,message:"标题名称不能为空",trigger:"blur"}],
          showSearchFlag:[{required:true,message:"不能为空",trigger:"blur"}],
        },
      }


    },
    created(){
      this.fitchList()
      let mytoken = getToken();
      this.importHeaders  = {"Authorization": mytoken}
      getStaticData("").then(response =>
        {
          let data = response.data;
          if (commonUtils.isObjectNull(data)){
            return;
          }
          this.uploadAction = data.uploadChildPhotoImageUrl+'/'+this.storeFrontId;
        })
    },
    mounted() {

    },
    methods: {
      statusFormatter(row, column, cellValue, index){
        if (cellValue==='1'){
          return '有效';
        }else{
          return '无效'
        }
      },
      booleanFormatter(row, column, cellValue, index){
        if (cellValue){
          return '是';
        }else{
          return '否'
        }
      },
      handleResetSearch(){
        this.queryParam={}
      },
      //点击查询按钮
      onBtnSearch() {
        this.fitchList();
      },
      handleCurrentChange(val) {
        this.queryParam.pageNum = val;
        this.fitchList();
      },
      handleSizeChange(val) {
        this.queryParam.pageSize = val;
        this.fitchList();
      },
      refreshData(list){
        this.tableData = list;
      },
      //添加一个
      handleCreateOne(){
        this.visibleDlgAdd = true;
      },
      onBtnOK(){
        this.visibleDlg = false;
        this.fitchList();
      },
      //新增保存
      onClassroom(data){
        data.shopFrontId =globaldata.getAdminStore().storeFrontId;
        addClassroom(data).then(response =>
        {
          messageUtils.successMsg(this,response.message)
          this.visibleDlg = false;
          this.fitchList();
        })
      },
      onBtnCancel(){
        this.visibleDlg = false;
      },

      handleEdit(row){
        this.visibleEditDlg = true;
        this.editParam = row
      },
      //刪除
      handleDeleteOne(row){
        this.$confirm('是否确认删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',

        }).then(() => {
          let param = {
            id:row.id,
          }
          tagInActiveById(param).then(response => {
            let code = response.code;
            if (code == 20000){
              messageUtils.successMsg(this,response.message);
              this.fitchList();
            }else {
              messageUtils.errorMsg(this,response.message);
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },
      fitchList(){
        this.listLoading = true;
        this.queryParam.storeFrontId = this.storeFrontId
        tagList(this.queryParam).then(response => {
          this.listLoading = false;
          let data = response.data;
          if (commonUtils.isObjectNull(data)){
            return;
          }
          this.queryParam.totalPage = data.total;

          this.refreshData(data.records);
        })
      },

      handleEditOne(){
        this.$refs['editForm'].validate(valid=>{
          if(valid){
            tagUpdate(this.editParam).then(response =>
            {
              let code = response.code;
              if (code == 20000){
                messageUtils.successMsg(this,response.message);
                this.visibleEditDlg= false;
                this.fitchList();
              }else {
                messageUtils.errorMsg(this,response.message);
              }
            })
            this.addParam={}
          }
        })
      },

      handleAddOne() {
        this.$refs['addForm'].validate(valid=>{
          if(valid){
            tagAdd(this.addParam).then(response =>
            {
              let code = response.code;
              if (code == 20000){
                messageUtils.successMsg(this,response.message);
                this.visibleDlgAdd= false;
                this.fitchList();
              }else {
                messageUtils.errorMsg(this,response.message);
              }
            })
            this.addParam={}
          }
        })
      },
    }
  }



</script>






// WEBPACK FOOTER //
// src/views/superadmin/store-tag/index.vue